import gql from 'graphql-tag';

const cancellationPrimerFragments = {
    CheckoutExperienceModel: gql`
        fragment CancellationPrimerCheckoutExperienceModel on CheckoutExperienceModel {
            cancellation {
                deadline
                title
                prettyDateTitle
                serviceFeeNotice
                tooltipTitle
                tooltipMessage
            }
        }
    `,
};

export default cancellationPrimerFragments;
